import { List, Text } from "@wayflyer/flyui";
import { useIntl } from "react-intl";
import { useCustomerAppConfig } from "undercarriage";

import { useFundingApplication, useFundingApplicationMutation } from "../../../queries/funding-application/queries";
import { UploadDocumentType } from "../../../types";
import { useStageOptOutCheckbox } from "../hooks";

import { DocumentUpload } from "./document-upload";
import { MESSAGES } from "./message-definitions";

export const DebtAgreementsDocumentUpload = ({
  includeHeader = false,
  error,
}: {
  includeHeader?: boolean;
  error?: string;
}): UIElement => {
  const intl = useIntl();
  const {
    data: { customerDomain },
  } = useCustomerAppConfig();

  const { data: fundingApplication } = useFundingApplication(customerDomain);
  const fundingApplicationMutation = useFundingApplicationMutation(customerDomain);
  const { canOptOutOfStage } = useStageOptOutCheckbox(UploadDocumentType.COMPANY_DEBT_AGREEMENT);

  const handleSkipCheckbox = async (checked: boolean) => {
    await fundingApplicationMutation.mutateAsync({ id: fundingApplication.id, isCompanyDebtAgreementSkipped: checked });
  };

  return (
    <DocumentUpload
      documentType={UploadDocumentType.COMPANY_DEBT_AGREEMENT}
      supportedFileExtensions={[".pdf", ".docx"]}
      fileSizeLimitMB={50}
      header={includeHeader ? intl.formatMessage(MESSAGES.debtAgreementsTitle) : undefined}
      description={
        <List type="bullet">
          <List.Item>
            <Text>{intl.formatMessage(MESSAGES.debtAgreementsDescriptionPoint1)}</Text>
          </List.Item>
        </List>
      }
      onSkipCheckbox={canOptOutOfStage ? handleSkipCheckbox : undefined}
      skipped={fundingApplication.isCompanyDebtAgreementSkipped}
      error={error}
    />
  );
};
